import script from "./AdminUsersRolesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsersRolesView.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsersRolesView.vue?vue&type=style&index=0&id=63a2ea7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a2ea7a"]])

export default __exports__